<div class="me-4" id="errorMessage">
  <div class="row errorColoring errorSpacing text-start errorText">
    <div *ngIf="errorMessage" class="col-10">
      <i class="fa fa-circle-o fa-lg circle-position"></i>
      <i class="fa fa-exclamation exclamation-position"></i>
      <p
        class="col errorTextColor ps-2 ms-4 input-validation-text"
        id="errorMessageText"
      >
        {{ getGenericErrorMessage() }}&nbsp; Try again or contact
        <a
          href="mailto:customercare@eyefinity.com?subject={{
            genericMessage
          }}&body=Error Info: {{ errorMessage | json }}"
          target="_blank"
          >customercare&#64;eyefinity.com</a
        >
        if this issue persists.
      </p>

      <pre
        *ngIf="showError"
        class="errorTextColor noScrollForPre"
        id="errorDetails"
        >{{ errorMessage | json }}</pre
      >
    </div>
    <div (click)="toggleError()" class="col-2 text-end detailsColor">
      <div
        [ngClass]="showError ? 'fa fa-minus-square-o' : 'fa fa-plus-square-o'"
        class="btn"
        id="errorButton"
      >
        Error Details
      </div>
    </div>
  </div>
</div>
